<template>
    <b-container fluid>
        <b-row>
            <transition name="fade" mode="out-in">
                <b-col md="4" lg="3" tag="router-view" name="sidebar" />
            </transition>
            <transition name="fade" mode="out-in">
                <b-col md="7" lg="8" class="mx-auto" tag="router-view" />
            </transition>
        </b-row>
    </b-container>
</template>

<script>
export default {
    props: {
        projectId: {
            type: [Number, String],
            default: null
        }
    }
}
</script>
